import React from "react";
import {
    DocumentTaxonomy,
    getMainDocumentTaxonomy,
} from "@common/documentCategories";
import TaxIcon from "@icons/documentTypes/Tax.svg?react";
import ReceiptsIcon from "@icons/documentTypes/Receipts.svg?react";
import AccountStatementsIcon from "@icons/documentTypes/AccountStatements.svg?react";
import LoanStatementsIcon from "@icons/documentTypes/LoanStatements.svg?react";
import LeaseStatementsIcon from "@icons/documentTypes/LeaseStatements.svg?react";
import FormationDocumentsIcon from "@icons/documentTypes/FormationDocuments.svg?react";
import LegalDocumentsIcon from "@icons/documentTypes/LegalDocuments.svg?react";
import ContributionDistributionIcon from "@icons/documentTypes/ContributionDistribution.svg?react";
import FinancialStatementsIcon from "@icons/documentTypes/FinancialStatements.svg?react";
import PayrollIcon from "@icons/documentTypes/Payroll.svg?react";
import ChecksIcon from "@icons/documentTypes/Checks.svg?react";
import AssetsIcon from "@icons/documentTypes/Assets.svg?react";
import TransactionRecordsIcon from "@icons/documentTypes/TransactionRecords.svg?react";
import OtherIcon from "@icons/documentTypes/Other.svg?react";
import UncategorizedIcon from "@icons/transactionCategories/Uncategorized.svg?react";

const ICON_MAP: Partial<Record<DocumentTaxonomy, React.ReactNode>> = {
    [DocumentTaxonomy.tax]: <TaxIcon />,
    [DocumentTaxonomy.receipts]: <ReceiptsIcon />,
    [DocumentTaxonomy.account_statements]: <AccountStatementsIcon />,
    [DocumentTaxonomy.loan_statements]: <LoanStatementsIcon />,
    [DocumentTaxonomy.lease_statements]: <LeaseStatementsIcon />,
    [DocumentTaxonomy.formation_documents]: <FormationDocumentsIcon />,
    [DocumentTaxonomy.legal_documents]: <LegalDocumentsIcon />,
    [DocumentTaxonomy.accounts_receivable_payable]: (
        <ContributionDistributionIcon />
    ),
    [DocumentTaxonomy.financial_statements]: <FinancialStatementsIcon />,
    [DocumentTaxonomy.payroll]: <PayrollIcon />,
    [DocumentTaxonomy.checks]: <ChecksIcon />,
    [DocumentTaxonomy.assets]: <AssetsIcon />,
    [DocumentTaxonomy.transaction_records]: <TransactionRecordsIcon />,
    [DocumentTaxonomy.uncategorized]: <UncategorizedIcon />,
    [DocumentTaxonomy.other]: <OtherIcon />,
};

interface DocumentCategoryIconProps {
    documentTaxonomy: DocumentTaxonomy;
}

export const DocumentCategoryIcon: React.FC<DocumentCategoryIconProps> =
    React.memo(({ documentTaxonomy }) => {
        const mainTaxonomy = getMainDocumentTaxonomy(documentTaxonomy);
        const icon = ICON_MAP[mainTaxonomy];
        if (!icon) {
            return null;
        }
        return <span className="icon-color-revert line-height-1">{icon}</span>;
    });
DocumentCategoryIcon.displayName = "DocumentCategoryIcon";
